import { Editions } from '../enums';

export interface AccountUpdate {
  edition: Editions;
  expiryDate: Date | undefined;
}
